module.exports = __webpack_public_path__ + "static/media/house8.38ae8d9d.png";